import { ActionContext } from '../helpers/ActionContext';
import { IServerUserInfo } from '../models/IServerUserInfo';
import { IUserSettings } from '../models/IUserSettings';
import { Module } from '../Module';
import { ServerUsers } from '../../userManagement/services/resources/ServerUsers';
import { IConnectedDevice } from '../ServerApi/types/IConnectedDevice';
import { DeleteConnectedDeviceAction } from '../services/DeleteConnectedDeviceAction';
import { PersonalAccessTokensService } from '../services/PersonalAccessTokensService';
import { UserSettingsCtrlCommon } from '../services/UserSettingsCtrlCommon';


export class ServerUserSettingsSubspaceCtrl {

  public static $inject = [
    '$scope',
    'DeleteConnectedDeviceAction',
    'PersonalAccessTokensService',
    'UserSettingsCtrlCommon',
  ];

  constructor(
            $scope: ServerUserSettingsSubspaceCtrl.Scope,
            deleteConnectedDeviceAction: DeleteConnectedDeviceAction,
            personalAccessTokensService: PersonalAccessTokensService,
            userSettingsCtrlCommon: UserSettingsCtrlCommon,
  ) {
    userSettingsCtrlCommon.initScope(
      $scope,
      $scope.isSessionUserSelf,
      $scope.serverUser,
      null, // There is no site user when displaying the server user setting page. Behavior needing the site user are disabled in that case (e.g. changing email address).
      $scope.userSettings,
      $scope.userRefreshTokenCount);

    // Connected devices

    const refreshTokensCallback = personalAccessTokensService.loadTokensIntoScope(<any>$scope, $scope.serverUser);

    const refreshConnectedDevices = () => ServerUsers.instance.getUserConnectedDevices($scope.serverUser.id)
      .then((devices: IConnectedDevice[]) => $scope.connectedDevices = devices).then(refreshTokensCallback);

    $scope.deleteConnectedDevice = (device: IConnectedDevice, $event: JQueryEventObject) =>
      deleteConnectedDeviceAction.execute(device, $scope.serverUser.id, ActionContext.fromEvent($event))
        .then(refreshConnectedDevices);

    personalAccessTokensService.loadActionsIntoScope(<any>$scope, $scope.serverUser, $scope.isSessionUserSelf, refreshConnectedDevices);

    refreshConnectedDevices();

  }

}

export module ServerUserSettingsSubspaceCtrl {

  export interface Scope extends UserSettingsCtrlCommon.Scope {
    connectedDevices: IConnectedDevice[];
    deleteConnectedDevice(token: IConnectedDevice, $event: JQueryEventObject): void;
    isSessionUserSelf: boolean;
    userSettings: IUserSettings;
    userRefreshTokenCount: number;
    serverUser: IServerUserInfo;
  }

}

Module.instance().controller('ServerUserSettingsSubspaceCtrl', ServerUserSettingsSubspaceCtrl);
